"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var get_or_default_1 = require("@hikakaku/shared/util/get_or_default");
var TabController = /** @class */ (function (_super) {
    __extends(TabController, _super);
    function TabController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTarget = '';
        _this.activeLabelClass = '';
        _this.activeContentClass = '';
        _this.connect = function () {
            var _a;
            (_a = _this.tabLabelTargets) === null || _a === void 0 ? void 0 : _a.forEach(function (label) {
                (0, jquery_1.default)(label).on('click', function (e) { return _this.selectTab((0, jquery_1.default)(e.target).data('target-tab-content')); });
            });
            _this.defaultTarget = (0, get_or_default_1.getOrDefault)(_this.data, 'default-target');
            _this.activeLabelClass = (0, get_or_default_1.getOrDefault)(_this.data, 'active-label-class');
            _this.activeContentClass = (0, get_or_default_1.getOrDefault)(_this.data, 'active-content-class');
            _this.selectTab();
        };
        _this.selectTab = function (targetName) {
            var _a, _b;
            if (targetName === void 0) { targetName = _this.defaultTarget; }
            (_a = _this.tabLabelTargets) === null || _a === void 0 ? void 0 : _a.forEach(function (label) {
                var labelElt = (0, jquery_1.default)(label);
                if (labelElt.data('target-tab-content') === targetName) {
                    labelElt.addClass(_this.activeLabelClass);
                }
                else {
                    labelElt.removeClass(_this.activeLabelClass);
                }
            });
            (_b = _this.tabContentTargets) === null || _b === void 0 ? void 0 : _b.forEach(function (content) {
                var contentElt = (0, jquery_1.default)(content);
                if (contentElt.data('tab-content-name') === targetName) {
                    contentElt.addClass(_this.activeContentClass);
                }
                else {
                    contentElt.removeClass(_this.activeContentClass);
                }
            });
        };
        return _this;
    }
    TabController.targets = ["tabLabel", "tabContent"];
    return TabController;
}(stimulus_1.Controller));
exports.default = TabController;
